import type Luminary from '@lumen5/luminary';
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { RootState } from 'js/src/libs/RootState';

type TextAssetsState = {
    luminaryInstance: Luminary | null;
    isReady: boolean;
};

const initialState: TextAssetsState = {
    luminaryInstance: null,
    isReady: false,
};

export const textAssetsSlice = createSlice({
    name: 'textAssets',
    initialState,
    reducers: {
        setTextAssetsLuminaryInstance: (state, action: PayloadAction<Luminary | null>) => {
            state.luminaryInstance = action.payload;
            state.isReady = action.payload !== null;
        },
    },
    selectors: {
        getTextAssetsLuminaryInstance: (state) => state.luminaryInstance,
        getTextAssetsIsReady: (state) => state.isReady,
    },
});

export const { setTextAssetsLuminaryInstance } = textAssetsSlice.actions;
export const { getTextAssetsLuminaryInstance, getTextAssetsIsReady } = textAssetsSlice.getSelectors(
    (state: RootState) => state.app.textAssets,
);
export default textAssetsSlice.reducer;
